import I18n from 'I18n';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { useCallback, useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { selectSearchQuery } from '../../selectors/searchState';
import { SEARCH, SEARCH_ACTIONS, SEARCH_ORIGINS } from '../../tracking/trackerActions';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import { getSearchResultsPageUrl, searchSanitizedAndEncodedQuery } from './searchHelpers';
import { useHistory } from 'react-router-dom';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useKeyboardShortcut } from './hooks/useKeyboardShortcut';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchInput = ({
  searchInput,
  setSearchInput,
  query
}) => {
  // Handles for setting the search input on deep link/redirect to search results page
  useEffect(() => setSearchInput(query), [setSearchInput, query]);
  const dispatch = useDispatch();
  const history = useHistory();
  const locale = useLocale();
  const searchInputRef = useRef(null);
  const onSubmit = useCallback(e => {
    getUsageTracker().track(SEARCH, {
      action: SEARCH_ACTIONS.REDIRECT_TO_RESULTS_PAGE,
      origin: SEARCH_ORIGINS.DROPDOWN_SEARCH,
      searchTerm: searchInput
    });
    e.preventDefault();
    searchSanitizedAndEncodedQuery(searchInput, locale, dispatch, false);
    const searchPageUrl = getSearchResultsPageUrl(searchInput);
    history.push(searchPageUrl);
  }, [dispatch, history, locale, searchInput]);
  const onChange = useCallback(e => {
    if (e.target.value === '' && searchInput !== '') {
      getUsageTracker().track(SEARCH, {
        action: SEARCH_ACTIONS.SEARCH_CLEARED,
        origin: SEARCH_ORIGINS.STANDARD_SEARCH
      });
    }
    setSearchInput(e.target.value);
  }, [searchInput, setSearchInput]);
  useKeyboardShortcut(['Cmd+K', '/'], () => {
    var _searchInputRef$curre;
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
  });
  return /*#__PURE__*/_jsx(UIForm, {
    onSubmit: onSubmit,
    children: /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('developer-docs-ui.header.search.placeholder'),
      children: /*#__PURE__*/_jsx(UISearchInput
      // @ts-expect-error types not happy
      , {
        ref: searchInputRef,
        "data-test-id": "search-input",
        autoComplete: "off",
        placeholder: I18n.text('developer-docs-ui.header.search.placeholder'),
        value: searchInput,
        onChange: onChange
      })
    })
  });
};
const mapStateToProps = state => ({
  query: selectSearchQuery(state)
});

/**  Used by the header on the Search Results Page and in the header on any page
 * for mobile view. OnSubmit is handled by the UIForm wrapper component in
 * `<Search />`
 */
export default compose(connect(mapStateToProps))(SearchInput);